<template>
  <div class="multipleChoiceCheckBox"
       :class="{ 'multipleChoiceCheckBox--noSetting': checkStatus === 'noSetting' }"
       @click="$emit('change-status')"
  >
    <div class="multipleChoiceCheckBox__icon">
      <Icon v-if="checkStatus === true" name="iconOk" />
      <Icon v-else-if="checkStatus === false" name="iconCrossRed" />
      <span v-else-if="checkStatus === 'noSetting'">
        -
      </span>
    </div>
    <p>
      {{ label }}
    </p>
  </div>
</template>

<script>
import Icon from './Icon'

export default {
  name: 'MultipleChoiceCheckBox',
  components: { Icon },
  props: {
    checkStatus: {
      required: true,
      validator: function (value) {
        // プロパティの値は、必ずいずれかでなければならない
        return ['noSetting', true, false].indexOf(value) !== -1
      }
    },
    label: {
      required: true,
      type: String
    }
  },
  emits: ['change-status']
}
</script>

<style lang="scss" scoped>
.multipleChoiceCheckBox {
  border: 1px solid #E4E7EB;
  display: flex;
  border-radius: 4px;
  padding: 16px 24px;
  cursor: pointer;
  &--noSetting {
    color: #9D9D9F;
  }
  &__icon {
    margin-right: 13px;
  }
}
</style>
